import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    const poll = async () => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch {
        setStatus("error");
        return;
      }
      attempts.current += 1;
      if (attempts.current < 12) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#060D1A] flex items-center justify-center px-4" data-testid="payment-success-page">
      <div className="w-full max-w-md rounded-3xl border border-white/15 bg-[#0F1B31]/80 p-10 text-center">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="h-12 w-12 text-white mx-auto mb-6" />
            <h1 className="font-display text-2xl font-bold text-white">You're all set</h1>
            <p className="mt-3 text-slate-400" data-testid="payment-success-message">
              Your subscription is active. We're already getting started on your account.
            </p>
          </>
        ) : status === "error" || status === "timeout" ? (
          <>
            <XCircle className="h-12 w-12 text-slate-400 mx-auto mb-6" />
            <h1 className="font-display text-2xl font-bold text-white">Confirming payment</h1>
            <p className="mt-3 text-slate-400">
              We're still confirming your payment — check your dashboard in a moment.
            </p>
          </>
        ) : (
          <>
            <Loader2 className="h-10 w-10 animate-spin text-white mx-auto mb-6" />
            <h1 className="font-display text-2xl font-bold text-white">Confirming your payment…</h1>
          </>
        )}
        <Link
          to="/dashboard"
          data-testid="payment-success-dashboard-link"
          className="mt-8 inline-flex items-center justify-center rounded-full bg-white px-8 py-3.5 text-base font-semibold text-[#060D1A] transition-colors duration-300 hover:bg-slate-300"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
